export default{
  apiKey: "AIzaSyB5x6CtAypI7qmKmhwc2rw-XQSBhqR0e5s",
  authDomain: "portafolio-5e8f6.firebaseapp.com",
  databaseURL: "https://portafolio-5e8f6.firebaseio.com",
  projectId: "portafolio-5e8f6",
  storageBucket: "portafolio-5e8f6.appspot.com",
  messagingSenderId: "322256524245",
  appId: "1:322256524245:web:e7b870952c84cf63fc235c",
  measurementId: "G-QSMMSL3L97"
};
